import { LocalDate } from './LocalDate';
import { LocalTime } from './LocalTime';
var LocalDateTime = /** @class */ (function () {
    function LocalDateTime(year, month, day, hour, minute, second, millisecond) {
        if (second === void 0) { second = 0; }
        if (millisecond === void 0) { millisecond = 0; }
        this.year = year;
        this.month = month;
        this.day = day;
        this.hour = hour;
        this.minute = minute;
        this.second = second;
        this.millisecond = millisecond;
        this.date = new LocalDate(year, month, day);
        this.time = new LocalTime(hour, minute, second, millisecond);
    }
    LocalDateTime.parse = function (s) {
        var match = /^(.+)T(.+)$/.exec(s);
        if (!match)
            throw new SyntaxError('Invalid LocalDateTime: ' + s);
        return LocalDate.parse(match[1]).atTime(LocalTime.parse(match[2]));
    };
    LocalDateTime.prototype.toJSON = function () {
        return this.date.toJSON() + 'T' + this.time.toJSON();
    };
    LocalDateTime.prototype.toString = function () {
        return this.toJSON();
    };
    LocalDateTime.prototype.toDate = function () {
        return new Date(this.year, this.month - 1, this.day, this.hour, this.minute, this.second, this.millisecond);
    };
    LocalDateTime.prototype.toLocaleString = function (locale) {
        return this.date.toLocaleString(locale) + ' ' + this.time.toHhmmssString();
    };
    return LocalDateTime;
}());
export { LocalDateTime };
